import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import 'component_ui/designer-profile-header';
import Accordion from 'component_ui/accordion';
import ContentToggle from 'component_ui/content-toggle';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';
import trackLink from '@99designs/common/utils/platform/trackLink';
import FormAddFragmentIdentifier from 'component_ui/form-add-fragment-identifier';
import LikeButton from 'component_ui/like';
import LikeData from 'component_data/like';
import SelectDropdown from 'component_ui/select-dropdown';
import SmallScreenOffCanvasFilters from 'component_ui/small-screen-off-canvas-filters';
import ToggleVisible from 'component_ui/toggle-visible';
import DropdownRepositioner from 'component_ui/dropdown-repositioner';
import HtmlUpdater from 'component_ui/html-updater';
import TabPanel from 'component_ui/tab-panel';

import ScrollToElement from 'component_ui/scroll-to-element';
import ShowHidden from 'component_ui/show-hidden';
import Testimonial from 'component_ui/testimonial';
import TestimonialData from 'component_data/testimonial';
import FavoriteButton from 'components/FavoriteButton';

import React from 'react';
import ReactDOM from 'react-dom';

import initIndicator from 'apps/online-status/initIndicator';
import { IntlProvider } from 'react-intl';

import initResponsivenessScore from 'apps/responsiveness-score/';
import ResponsivenessScoreStatsPanelItem from 'apps/responsiveness-score/components/responsiveness-score-stats-panel-item';

const initOnlineStatus = () => {
    const lastSeenIndicator = document.querySelector('[data-last-seen-times-url]');
    if (lastSeenIndicator) {
        initIndicator(lastSeenIndicator);
    }
};

const responsivenessScoreNode = document.querySelector(
    '[data-responsiveness-score-origin=profiles]'
);

document.addEventListener('DOMContentLoaded', () => {
    // Favorite button
    const appNode = document.getElementById('profile-header-favorite-button');
    const dataNode = document.getElementById('profile-header-favorite-button-data');

    if (dataNode && appNode) {
        const { initData } = JSON.parse(dataNode.textContent);
        const { favoriteUrl, intlMessages, isFavorite } = initData;

        ReactDOM.render(
            <IntlProvider locale={document.documentElement.lang} messages={intlMessages}>
                <FavoriteButton isFavorite={isFavorite} favoriteUrl={favoriteUrl} />
            </IntlProvider>,
            appNode
        );
    }

    initOnlineStatus();

    if (responsivenessScoreNode) {
        initResponsivenessScore(responsivenessScoreNode, ResponsivenessScoreStatsPanelItem);
    }

    Accordion.attachTo('[data-accordion]');

    ContentToggle.attachTo('[data-contest-invites]');

    const dropdowns = DetachedDropdown.createAll('[data-detached-dropdown]');

    $('[data-flight-like-button]').each(function() {
        LikeData.attachTo(this, {
            likeUrl: $(this).data('like-url'),
        });
    });
    LikeButton.attachTo('[data-flight-like-button]');

    TabPanel.attachTo('[data-tab-panelset]', { useHistory: true });

    $('[data-login-signup-like-button]').on('click', () => {
        $(document).trigger('uiLikeButtonClicked');
    });

    $(document).on('click', function(e) {
        $(this).trigger('uiCloseSelectDropdown', { target: e.target });
        $(this).trigger('uiHideToggleVisible', { target: e.target });
    });

    ShowHidden.attachTo('[data-show-hidden]');

    ToggleVisible.attachTo('[data-toggle-visible]', {
        hideOnBodyClick: true,
    });

    Testimonial.attachTo('[data-testimonial]');
    TestimonialData.attachTo('[data-testimonial]');

    $('[data-small-screen-off-canvas-filters-button]').on('click', function() {
        const $self = $(this);
        $(document).trigger('uiActivateSmallScreenOffCanvasFilters', {
            name: $self.attr('data-small-screen-off-canvas-filters-button-name'),
        });
    });

    SelectDropdown.attachTo('[data-category-selector]', {
        submitParentForm: true,
    });
    SelectDropdown.attachTo('[data-sort-selector]', {
        submitParentForm: true,
    });
    ToggleVisible.attachTo('[data-toggle-visible]', {
        hideOnBodyClick: true,
    });

    SmallScreenOffCanvasFilters.attachTo('[data-small-screen-off-canvas-filters]');

    FormAddFragmentIdentifier.attachTo('[data-form-add-fragment-identifier]');

    HtmlUpdater.attachTo('[data-login-signup-container]', {
        eventName: 'uiLikeButtonClicked',
        templateSelector: "[data-update-html-template='login-or-signup']",
    });

    DropdownRepositioner.attachTo('[data-login-signup-like-button]', {
        eventName: 'uiLikeButtonClicked',
        dropdowns,
    });

    $('[data-tooltip]').tooltip();
    ScrollToElement.attachTo('[data-scroll-to-element]');

    // Track Invite Designer Button
    const inviteCtas = document.querySelectorAll('[data-track-invite-designer]');

    Array.from(inviteCtas).forEach(cta => {
        trackLink(cta, 'Clicked Invite Designer Button on Designer Profile', {
            designer_id: cta.getAttribute('data-track-invite-designer'),
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/page/profiles-profiles.js